import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {Link} from "react-router-dom";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDisclaimer: false
        };
    }

    componentDidMount() {
        const today = new Date().toISOString().split("T")[0]; // yyyy-mm-dd

        const lastShown = localStorage.getItem("secretariat_disclaimer_shown_date");

        if (lastShown !== today) {
            // Show the modal only if NOT shown today
            this.setState({ showDisclaimer: true });
            localStorage.setItem("secretariat_disclaimer_shown_date", today);
        }
    }

    closeDisclaimer = () => {
        this.setState({ showDisclaimer: false });
    };

    render() {
        return (
            <>
                {/* Disclaimer Modal */}
                <Modal show={this.state.showDisclaimer} onHide={this.closeDisclaimer} centered>
                    <Modal.Header>
                        <Modal.Title>Data Privacy Statement</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>At Tangent India, our community thrives on <strong>trust and respect</strong>. Your privacy is paramount, and we are committed to safeguarding your personal information.</p>
                        <p>We collect essential details like your name, email, phone number, and other relevant information to maintain an accurate member directory. This enables secure and respectful connections among our members. Additionally, TBNI members' business profiles are included in this directory.</p>
                        <p><strong>Shared Responsibility</strong>: Please protect fellow members' privacy. <strong>Do not share personal details without explicit permission</strong>. TBNI business profiles, however, are shareable.</p>
                        <p>Thank you for helping us keep Tangent India a trusted, respectful, and secure community for all.</p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={this.closeDisclaimer}>
                            I Accept
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Container>
                    <Row>
                        <h2>Members</h2>
                    </Row>
                    <Row>
                        {this.props.scopes.includes('secretariat') &&
                            <>
                                <Col md className={'text-center'}>
                                    <Button variant='outline-secondary' as={Link} to={'/members/add'}>New Member</Button>
                                </Col>
                                <Col md className={'text-center'}>
                                    <Button variant='outline-secondary' as={Link} to={'/members/edit'}>Edit/Delete Member</Button>
                                </Col>
                                <Col md className={'text-center'}>
                                    <Button variant='outline-secondary' as={Link} to={'/applications'}>New Member Forms</Button>
                                </Col>
                                {/*<Col md className={'text-center'}>*/}
                                {/*    <Button variant='outline-secondary' as={Link} to={'/events'}>Events</Button>*/}
                                {/*</Col>*/}
                                {/*<Col md className={'text-center'}>*/}
                                {/*    <Button variant='outline-secondary' as={Link} to={'/members/email'}>View By Email</Button>*/}
                                {/*</Col>*/}
                                <Col md className={'text-center'}>
                                    <Button variant='outline-secondary' as={Link} to={'/add-club'}>Add Club</Button>
                                </Col>
                            </>
                        }
                        {/*{(this.props.scopes.includes('secretariat') || this.props.scopes.includes('nationalBoard'))  &&*/}
                        {/*<>*/}
                        {/*    <Col md className={'text-center'}>*/}
                        {/*        <Button variant='outline-secondary' as={Link} to={'/events'}>Events</Button>*/}
                        {/*    </Col>*/}
                        {/*</>*/}
                        {/*}*/}
                        {/*<Col md className={'text-center'}>*/}
                        {/*    <Button variant='outline-secondary' as={Link} to={'/ab-form'}>A & B Forms</Button>*/}
                        {/*</Col>*/}
                    </Row>
                </Container>
            </>
        );
    }
}